import { render, staticRenderFns } from "./HeaderMenuItem.vue?vue&type=template&id=3d480c86&scoped=true"
import script from "./HeaderMenuItem.vue?vue&type=script&lang=js"
export * from "./HeaderMenuItem.vue?vue&type=script&lang=js"
import style0 from "./HeaderMenuItem.vue?vue&type=style&index=0&id=3d480c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d480c86",
  null
  
)

export default component.exports